import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getSettingRequest: ['response'],
    getSettingSuccess: ['response', 'loading'],
    getSettingFailure: ['error'],
})

export const getSettingTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getSettingSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getSettingFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getSettingRequest = state => state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_SETTING_REQUEST]: getSettingRequest,
    [Types.GET_SETTING_SUCCESS]: getSettingSuccess,
    [Types.GET_SETTING_FAILURE]: getSettingFailure,
})
